import {
  DndContext,
  type DragEndEvent,
  PointerSensor,
  type UniqueIdentifier,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import type { TableProps } from 'antd';
import { Table } from 'antd';

import { DraggableRow } from './DraggableRow';
import styles from './DraggableTable.module.scss';

interface IProp<T> extends TableProps<T> {
  keysForSorting: (
    | UniqueIdentifier
    | {
        id: UniqueIdentifier;
      }
  )[];
  onDragEnd: (event: DragEndEvent) => void;
}

export const DraggableTable = <T,>({ keysForSorting, onDragEnd, ...rest }: IProp<T>) => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 1,
      },
    }),
  );

  return (
    <DndContext
      sensors={sensors}
      modifiers={[restrictToVerticalAxis]}
      onDragEnd={onDragEnd}
    >
      <SortableContext
        items={keysForSorting}
        strategy={verticalListSortingStrategy}
      >
        <Table
          className={styles.table}
          components={{
            body: { row: DraggableRow },
          }}
          {...rest}
        />
      </SortableContext>
    </DndContext>
  );
};
